import React, { useState, useEffect } from 'react'

import { useNavigate, useParams } from 'react-router-dom'

import LocalStorageService from '../services/LocalStorageService'
import NotificationService from '../services/NotificationService'
import UserService from '../services/UserService';
import FormService from '../services/FormService'
import OrganisationTagService from '../services/OrganisationTagService'
import { getRecordTerm } from '../services/TermsService'


// Font Awesome

// Appt Components
import Anchor from '../components/simple/anchor/Anchor'
import Box from '../components/simple/box/Box'
import Text from '../components/simple/text/Text'
import Select from '../components/simple/input/Select'

import ResponsiveGrid from '../components/compound/responsiveGrid/ResponsiveGrid'

// Shared Components
import BreadcrumbBar from './shared/BreadcrumbBar'
import ActionBoxLarge from '../components/compound/actionBox/ActionBoxLarge'
import ClickerGroups from './shared/ClickerGroups'
import { ResponsiveContext } from 'grommet';

function Record (props) {
    const navigate = useNavigate()

    const apiToken = LocalStorageService.get('apiToken')
    const activeOrg = LocalStorageService.get('activeOrg')
    const activeUser = LocalStorageService.get('userDetails')
    const terms = LocalStorageService.get('terms');

    const [allStudents, setAllStudents] = useState([]);
    const [studentValues, setStudentValues] = useState([]);
    const [activeStudent, setActiveStudent] = useState(null);

    const [selectedAction, setSelectedAction] = useState('custom');
    const [planActions, setPlanActions] = useState([]);
    const [recordActions, setRecordActions] = useState([]);
    const [communicationActions, setCommunicationActions] = useState([]);

    const [showClicker, setShowClicker] = useState(false);

  const [quickBehaviourGroups, setQuickBehaviourGroups] = useState([])

    const params = useParams()

    const id = params.id

    useEffect(() => {
        if (apiToken && activeOrg) {
          void OrganisationTagService.getActiveQuickBehaviourGroups(apiToken, activeOrg).then((response) => {
            setQuickBehaviourGroups(response)
            })
        }
    }, [])

    const getUsers = async (type = 'user') => {
        const params = {
            fields: 'id,firstName,lastName,reference,type',
            limit: 2000,
            orgId: activeOrg.id,
            showFormerStudents: 'false',
            type,
        };

        //   setLoading(true);
        const users = await UserService.getUsers(apiToken, params);
        if (!users || users?.error) {
            // NotificationService.error(users.error)
        } else {
            // if (!unmounted) {
            if (users?.error) {
                setStudentValues(null);
                setAllStudents(null);
            } else if (users?.data) {
                var studentUsers = [];
                for (const thisUser of users.data) {
                if (thisUser.firstName && thisUser.lastName) {
                    studentUsers.push({
                    id: thisUser.id,
                    learnerNumber: thisUser.reference,
                    name: thisUser.firstName + ' ' + thisUser.lastName,
                    });
                }
                }
                studentUsers = studentUsers.sort((a, b) =>
                a.name.localeCompare(b.name),
                );
                setStudentValues(studentUsers);
                setAllStudents(studentUsers);
            }
            // }
        }

    }

    const selectActionHandler = (action) => {

        if (action.showClicker) {
            setShowClicker(true);
        } else {
            navigate(action.href)
        }

    }

    const recordQuickBehaviour = async (behaviour) => {

        const data = {
            user: activeUser.id,
            organisation: activeOrg.id,
            status: 'Published',
            type: 'clicker',
            subType: behaviour,
            reference: '',
            responses: [{
                questionKey: 'quickBehaviour',
                questionText: 'n/a',
                response: behaviour,
                responseType: 'string'
            }],
            subject: activeStudent.id
        }

        var submissionAdded = await FormService.makeSubmissions(apiToken, data)
        if (submissionAdded.error) {
                NotificationService.error(submissionAdded.error);
        } else {
            NotificationService.success(behaviour + ' Recorded')
        }
    }

    const populateActions = async (id = 'new') => {
        let newPlanActions = []
        let newRecordActions = []
        let newCommunicationActions = []

        if (activeOrg?.plan === 'Plus' || activeOrg?.plan === 'Care') {
            newRecordActions = newRecordActions.concat([
                {
                'title': getRecordTerm(terms, 'physicalReportTerm', 'Physical Intervention Report'),
                    'href' : `/incident/high-level/${id}/edit`,
                    'description' : 'Record incident involving Physical Intervention',
                },
                {
                  'title': getRecordTerm(terms, 'incidentReportTerm', 'Incident Report'),
                    'href' : `/incident/${id}/edit`,
                    'description' : 'Record incident that did not involve Physical Intervention',
                }
            ])
        } else {
            newRecordActions = newRecordActions.concat([
                {
                'title': getRecordTerm(terms, 'incidentReportTerm', 'Incident Report'),
                    'href' : `/incident/${id}/edit`,
                    'description' : 'Record Incident',
                }
            ])
        }

        newPlanActions = newPlanActions.concat([
          {
            'title': getRecordTerm(terms, 'smartPlanBuilderTerm', 'Smart Plan Builder'),
              'href' : `/behaviour/${id}/edit`,
            'description': `View, Edit or Create a new ${getRecordTerm(terms, 'smartPlanBuilderTerm', 'Smart Plan')}`,
          },
          // {
          //     'title' : 'Smart Plan Builder (Legacy)',
          //     'href' : `/behaviour-legacy/${id}/edit`,
          //     'description' : 'The original Smart Plan Builder, for a limited time only',
          // },
        ])

        newCommunicationActions = newCommunicationActions.concat([
            {
            'title': getRecordTerm(terms, 'communicationTerm', 'Behaviour Communications'),
                'href' : `/log/${id}/edit`,
                'description' : 'Communicate notable behaviour to key staff',
            },
            // {
            //     'title' : 'Note',
            //     'href' : `/log/${id}/edit`,
            //     'description' : 'Record a note about this ' + (terms?.serviceUser || 'service user')?.toLowerCase(),
            // },
            // {
            //     'title' : 'Messenger',
            //     'href' : `/serviceuser/${id}/profile/messenger`,
            //     'description' : 'View and send messages about this ' + (terms?.serviceUser || 'service user')?.toLowerCase(),
            // },
        ])
        setCommunicationActions(newCommunicationActions);
        setRecordActions(newRecordActions)
        setPlanActions(newPlanActions);
    }
    useEffect(() => {
        populateActions(activeStudent?.id);
    }, [activeStudent, activeOrg?.plan, terms?.physicalReportTerm, terms?.incidentReportTerm, terms?.smartPlanBuilderTerm, terms?.communicationTerm]);

    useEffect(() => {
        if (id && studentValues.length > 0) {
            const selectedStudent = studentValues.find((student) => parseInt(student.id) === parseInt(id));
            setActiveStudent(selectedStudent);
        }
    }, [studentValues, id]);

    useEffect(() => {
        getUsers('student');
    }, []);

  return (
    <ResponsiveContext.Consumer>
      {(size) => {
        return (
        <>
            <BreadcrumbBar
                title="Record & Plan"
                path={
                <>
                    <Anchor href="/">BehaviourSmart</Anchor>
                    <Text color="besmartBlue" size="xsmall">
                    {window.location.pathname}
                    </Text>
                </>
                }
            />

            <Box
                background="white"
                direction="column"
                gap="small"
                margin={{ bottom: 'small' }}
                round="small"
                >
                <Box
                    justify="between"
                    pad={{ horizontal: 'medium', vertical: 'small' }}
                >
                    <Text margin={{ top: 'xsmall', bottom: 'xsmall' }} size="xlarge">
                    Select {(terms?.serviceUser || 'service user')}
                    </Text>
                    <Box

                    border={{ side: 'all', color: 'brand', size: 'medium' }}
                    round="small"
                >
                    <Select
                        onChange={({ option }) => setActiveStudent(option)}
                        labelKey="name"
                        placeholder={
                            'Select ' +
                            (terms?.serviceUser || 'service user')
                        }
                        options={studentValues}
                        value={activeStudent ? [activeStudent] : []}
                        onSearch={text => {

                            // The line below escapes regular expression special characters:
                            // [ \ ^ $ . | ? * + ( )
                            const escapedText = text.replace(
                            /[-\\^$*+?.()|[\]{}]/g,
                            '\\$&',
                            );
                            // Create the regular expression with modified value which
                            // handles escaping special characters. Without escaping special
                            // characters, errors will appear in the console
                            const exp = new RegExp(escapedText, 'i');

                            setStudentValues(allStudents.filter(o => exp.test(o.name)));
                        }}
                        valueKey={{ key: 'id', reduce: false }}
                        margin={{ left: 'small', right: 'small' }}
                        plain
                    />
                    </Box>
                </Box>
            </Box>


          {!activeStudent && <Box
            background="white"
            direction="column"
            gap="small"
            margin={{ bottom: 'small' }}
            round="small"
          >
            <Box
              justify="between"
              pad={{ horizontal: 'medium', vertical: 'small' }}
            >
              <Text color='besmartBlue'>
                Select a {(terms?.serviceUser || 'service user')?.toLowerCase()} to continue
              </Text>
            </Box>
          </Box>}


            {activeStudent && <>


              <ClickerGroups groups={quickBehaviourGroups} size={size} title="Behaviour Clicker" onClickBehaviour={recordQuickBehaviour} />

                <Box background='white' direction='column' gap='small' margin={{ top: 'medium', bottom: 'small' }} round='small' flex='grow'>
                    <Box direction='row-responsive' justify='between' pad={{ horizontal: 'medium', vertical: 'small' }}>
                        <Text size="xlarge" weight="bold" color='secondary'>
                            Record
                        </Text>
                    </Box>
                </Box>

                <ResponsiveGrid
                    rows={['auto']}
                    columns={{
                      small: ['auto'],
                      medium: ['auto', 'auto'],
                      large: ['40%', '40%'],
                      xlarge: ['40%', '40%'],
                    }}
                    gap="small"
                    >
                    { Object.keys(recordActions).map((key) => (
                        <ActionBoxLarge
                            key={key}
                            title={recordActions[key].title}
                            description={recordActions[key].description}
                            onClick={() => selectActionHandler(recordActions[key])}
                        />
                    ))}

            </ResponsiveGrid>

            <Box background='white' direction='column' gap='small' margin={{ top: 'medium', bottom: 'small' }} round='small' flex='grow'>
              <Box direction='row-responsive' justify='between' pad={{ horizontal: 'medium', vertical: 'small' }}>
                <Text size="xlarge" weight="bold" color='secondary'>
                  Communications
                </Text>
              </Box>
            </Box>

            <ResponsiveGrid
                rows={['auto']}
                columns={{
                  small: ['auto'],
                  medium: ['auto', 'auto'],
                  large: ['40%', '40%'],
                  xlarge: ['40%', '40%'],
                }}
                gap="small"
                >
                { Object.keys(communicationActions).map((key) => (
                    <ActionBoxLarge
                        key={key}
                        title={communicationActions[key].title}
                        description={communicationActions[key].description}
                        onClick={() => selectActionHandler(communicationActions[key])}
                    />
                ))}

            </ResponsiveGrid>

            <Box background='white' direction='column' gap='small' margin={{ top: 'medium', bottom: 'small' }} round='small' flex='grow'>
                <Box direction='row-responsive' justify='between' pad={{ horizontal: 'medium', vertical: 'small' }}>
                    <Text size="xlarge" weight="bold" color='secondary'>
                        Plan
                    </Text>
                </Box>
            </Box>
            <ResponsiveGrid
                    rows={['auto']}
                    columns={{
                      small: ['auto'],
                      medium: ['auto', 'auto'],
                      large: ['40%', '40%'],
                      xlarge: ['40%', '40%'],
                    }}
                    gap="small"
                    >

                { Object.keys(planActions).map((key) => (
                    <ActionBoxLarge
                        key={key}
                        title={planActions[key].title}
                        description={planActions[key].description}
                        onClick={() => selectActionHandler(planActions[key])}
                    />
                ))}
            </ResponsiveGrid>


          </>}



        </>
      )}}
    </ResponsiveContext.Consumer>
  );
}

export default Record
